<template>
    <div>
        <q-btn v-show="!loading" :icon="is_like ? 'favorite' : 'favorite_border'" style="color: #800000;" size="md" flat round @click="like" />
        <q-circular-progress v-show="loading" indeterminate color="primary" />
    </div>
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';

export default {
    name: 'ButtonLike',
    mixins: [uiControlMixin],
    mounted () {
        this.init();
    },
    data () {
        return {
            is_like: false,
            loading: false,
        };
    },
    computed: {
        userId () {
            const { user } = this.$store.state.pages;
            if (!user) {
                return undefined;
            }
            return user.id;
        },
    },
    methods: {
        init () {
            this.loading = true;
            this.$db.users.getUserLike(this.userId, this.page.id, this.view.id).then((r) => {
                this.is_like = r === '1';
                this.loading = false;
            });
        },
        like () {
            this.is_like = !this.is_like;
            const payload = {
                user_id: this.userId,
                page_id: this.page.id,
                view_id: this.view.id,
                is_like: this.is_like ? '1' : '0',
                page_title: this.page.title,
                view_name: this.view.name,
            };
            this.$db.users.sendUserLike(payload).then(() => {
                /*
                if (this.is_like) {
                    this.$q.notify('Спасибо за Ваш голос!');
                }
                 */
            });
        },
    },
};
</script>

<style scoped>

</style>
